var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDailyTraceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 14002",
    transform: "translate(3.0912 2.9088)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 474",
    y: 0.503493,
    width: 9.81818,
    height: 9.56643,
    rx: 2.01399,
    fill: "#F3F6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 479",
    d: "M7.0488 8.30769C7.0488 7.75154 7.49964 7.3007 8.05579 7.3007H9.81803V8.05594C9.81803 9.16824 8.91633 10.0699 7.80404 10.0699H7.0488V8.30769Z",
    fill: "#CEE3EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 475",
    d: "M0 2.51748C0 1.40519 0.901692 0.503493 2.01399 0.503493H7.80419C8.91649 0.503493 9.81818 1.40519 9.81818 2.51748V3.02098H0V2.51748Z",
    fill: "#37B1E5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 476",
    x: 2.01383,
    width: 0.755245,
    height: 2.01399,
    rx: 0.377622,
    fill: "#666A6F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 477",
    x: 4.53125,
    y: 0.00000265063,
    width: 0.755245,
    height: 2.01399,
    rx: 0.377622,
    fill: "#666A6F"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 478",
    x: 7.0488,
    width: 0.755245,
    height: 2.01399,
    rx: 0.377622,
    fill: "#666A6F"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_0_45",
    fill: "#2AC682"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "stroke1_0_45",
    maskUnits: "userSpaceOnUse",
    x: 2.28125,
    y: 3.9227,
    width: 5,
    height: 4,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 2.28125,
    y: 3.9227,
    width: 5,
    height: 4
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#stroke0_0_45"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6.46318 4.99477C6.44164 4.97193 6.41601 4.95381 6.38778 4.94144C6.35954 4.92907 6.32925 4.9227 6.29866 4.9227C6.26807 4.9227 6.23779 4.92907 6.20955 4.94144C6.18131 4.95381 6.15568 4.97193 6.13414 4.99477L4.40784 6.81225L3.68257 6.04725C3.6602 6.02454 3.6338 6.00667 3.60487 5.99469C3.57594 5.9827 3.54504 5.97682 3.51395 5.97739C3.48286 5.97795 3.45218 5.98495 3.42366 5.99798C3.39514 6.01102 3.36934 6.02983 3.34774 6.05334C3.32613 6.07686 3.30914 6.10462 3.29774 6.13504C3.28634 6.16545 3.28075 6.19794 3.28129 6.23063C3.28182 6.26332 3.28848 6.29558 3.30088 6.32556C3.31327 6.35555 3.33116 6.38267 3.35353 6.40539L4.24332 7.34093C4.26487 7.36376 4.29049 7.38189 4.31873 7.39426C4.34697 7.40662 4.37726 7.41299 4.40784 7.41299C4.43843 7.41299 4.46872 7.40662 4.49696 7.39426C4.52519 7.38189 4.55082 7.36376 4.57236 7.34093L6.46318 5.35291C6.4867 5.33009 6.50547 5.3024 6.51831 5.27158C6.53115 5.24076 6.53778 5.20748 6.53778 5.17384C6.53778 5.14019 6.53115 5.10691 6.51831 5.07609C6.50547 5.04527 6.4867 5.01758 6.46318 4.99477V4.99477Z",
    strokeWidth: 0.383121,
    stroke: "#2AC682",
    mask: "url(#stroke1_0_45)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "stroke0_0_45",
    d: "M6.46318 4.99477C6.44164 4.97193 6.41601 4.95381 6.38778 4.94144C6.35954 4.92907 6.32925 4.9227 6.29866 4.9227C6.26807 4.9227 6.23779 4.92907 6.20955 4.94144C6.18131 4.95381 6.15568 4.97193 6.13414 4.99477L4.40784 6.81225L3.68257 6.04725C3.6602 6.02454 3.6338 6.00667 3.60487 5.99469C3.57594 5.9827 3.54504 5.97682 3.51395 5.97739C3.48286 5.97795 3.45218 5.98495 3.42366 5.99798C3.39514 6.01102 3.36934 6.02983 3.34774 6.05334C3.32613 6.07686 3.30914 6.10462 3.29774 6.13504C3.28634 6.16545 3.28075 6.19794 3.28129 6.23063C3.28182 6.26332 3.28848 6.29558 3.30088 6.32556C3.31327 6.35555 3.33116 6.38267 3.35353 6.40539L4.24332 7.34093C4.26487 7.36376 4.29049 7.38189 4.31873 7.39426C4.34697 7.40662 4.37726 7.41299 4.40784 7.41299C4.43843 7.41299 4.46872 7.40662 4.49696 7.39426C4.52519 7.38189 4.55082 7.36376 4.57236 7.34093L6.46318 5.35291C6.4867 5.33009 6.50547 5.3024 6.51831 5.27158C6.53115 5.24076 6.53778 5.20748 6.53778 5.17384C6.53778 5.14019 6.53115 5.10691 6.51831 5.07609C6.50547 5.04527 6.4867 5.01758 6.46318 4.99477V4.99477Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDailyTraceIcon);
export default __webpack_public_path__ + "static/media/daily-trace-icon.5228821caae42a72c6bf3c0f89aad407.svg";
export { ForwardRef as ReactComponent };